import { string } from 'prop-types';
import React from 'react';
import TooltipBase from './TooltipBase';
import style from './style';


const ErrorTooltip = ({text, ...props}) => {
	return (
		<TooltipBase {...props}
			render={()=>(
				<React.Fragment>
					<style.ErrorTooltip.ErrorText> Error : {text}</style.ErrorTooltip.ErrorText>
				</React.Fragment>
			)}
		/>
	);
};

ErrorTooltip.propTypes = {
	text: string,
};

export default ErrorTooltip;